import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Button from '@material-ui/core/Button/Button';
import { CONVERT_HTML_PDF } from 'settings';
import Translate from 'components/Translate';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SvgIcon } from 'components/SvgIcon';
import { legacyPixelService, enLegacyPixelPath } from 'services/LegacyPixelService';
import { enPixelPath, pixelService } from 'services/PixelService';

interface IState extends IStateBase {
  downloading: boolean;
}

interface IProps {
  bankslipUrl: string;
  thankyouUrl?: string;
}

export default class Download extends BaseComponent<IState, IProps> {
  constructor(props: any) {
    super(props);
    this.state = { downloading: false };
  }

  handleClick = () => {
    /*
      legacyPixelService: Should be removed in not too distance future
    */
    legacyPixelService.track(enLegacyPixelPath.BANKSLIP);

    pixelService.setPath(enPixelPath.BANKSLIP_VIEW);

    this.setState({ downloading: true });
    setTimeout(() => this.setState({ downloading: false }), 10000);

    if (this.props.bankslipUrl.match(/pay\.dlocal\.com/)) {
      window.top.location.href = this.props.bankslipUrl;
      return;
    }

    if (this.props.bankslipUrl.match(/live\.adyen\.com/)) {
      window.top.location.href = this.props.bankslipUrl;
      return;
    }

    window.top.location.href = `${CONVERT_HTML_PDF}${this.props.bankslipUrl}`;

    this.handleRedirect();
  };

  handleRedirect = () => {
    if (!!this.props.thankyouUrl) {
      setTimeout(() => (window.location.href = this.props.thankyouUrl), 4000);
    }
  };

  render() {
    return (
      <div className={'bankslip-download'}>
        {!this.state.downloading ? (
          <Button onClick={this.handleClick}>
            <SvgIcon name="download" />
            <Translate term={'BAIXAR BOLETO'} />
          </Button>
        ) : (
          <Button disabled>
            <CircularProgress size={18} style={{ color: '#fff' }} />
          </Button>
        )}
      </div>
    );
  }
}
